module.exports = __webpack_public_path__ + "static/media/notification.0e3eff5d.png";